import React from 'react'

export default ({error}) => {
  if (!error) return null

  return(<label className="error">{error}</label>)
}